<template>
  <b-container class="p-5">
    <b-row class="my-5">
      <b-col class="my-2">
        <date-range-picker
          class="w-100"
          :startDate="dateRange[0]"
          :endDate="dateRange[1]"
          type="date"
          :customRanges="ranges"
          @date-select="filterPayablesAnalyticsByDate" />
      </b-col>
      <b-col class="my-2">
        <multiselect-dropdown
          v-if="merchantsList.length"
          class="w-100"
          allLabel="All Merchants"
          :options="merchantsList"
          :hasMore="hasMoreMerchants"
          :loadingMore="merchantsLoadingMore"
          :searchResults="merchantsSearchResults"
          :searchResultsLoading="merchantsSearchLoading"
          :multiple="true"
          :sideSingle="true"
          :value="queryMerchant"
          @item-select="filterMerchants"
          @load-more="loadMoreMerchants"
          @search-input="onMerchantsSearchInput"/>
      </b-col>
    </b-row>
    <b-row v-for="([key, rows], index) in Object.entries(data)" :key="'Section_'+index">
      <b-col>
        <b-row align-h="start">
          <b-col class="font-size-h2 py-2">{{key}}</b-col>
        </b-row>
        <b-row v-for="(item_row, indexR) in rows" :key="'Row'+indexR" 
            align-h="start" >
          <b-col v-for="(card, indexC) in item_row" :key="'Card'+indexC" md="3" sm="6" align-self="center" class="my-2">
            <kpi-card :card-data="card" :loading="loading"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import AnalyticsService from "@/services/analytics.service";
import DateRangePicker from "@/views/pages/companies/components/DateRangePicker.vue";
import kpiCard from "./components/kpiCard.vue";
import { DateRanges} from '@/dateRanges.js'
import { DateTime } from "luxon";
import MultiselectDropdown from "../../../components/multiselect.dropdown.vue";
import { GET_ALL_MERCHANTS, LOAD_MORE_MERCHANTS, SEARCH_MERCHANTS, CLEAR_MERCHANTS_SEARCH } from "@/store/monthlydata";
import { mapState } from 'vuex';
import { validateAdminQueryParameter } from "@/store/invoice/helpers";
import { QUERY_PARAMETERS_ACTIONS } from "@/store/queryparams";
export default {
  name: "nice",
  components: {
    DateRangePicker,
    MultiselectDropdown,
    kpiCard,
  },
  data() {
    return {
      data: {
        "Business":[
          [{label:"Merchants"},{label:"Payers"}, {label:"Buyers"}, {label:"Users"}]
        ],
        "Invoice":[
          [{label:"Invoices"},{label:"Invoices Volume"}],
          [{label:"Payments"},{label:"Payment Volumes"}, {label:"% Paid", postfix:"%"}, { label:"% Paid Volumes", postfix:"%"}],
          [{label:"Payments (Kema)"},{label:"Payment Volumes (Kema)"}, {label:"% Kema Paid", postfix:"%"}, { label:"% Kema Paid Volumes", postfix:"%"}],
        ],
        "Emails":[[{label:"Emails Sent"},{label:"Emails Viewed"}],[{label:"Buyers"},{label:"Invoices Opened"}]]
      },
      loading: true,
      merchant: null,
      queryMerchant:null,
      dateRange: [],
      diffDays: 0,
      ranges: DateRanges
    };
  },
  created() {
    this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
    this.$store.dispatch(GET_ALL_MERCHANTS, { is_merchant: "True" })
      .catch(({ message }) => {
        this.error = "There was an error loading companies.";
      });
    if (this.$route.query.due_start && this.$route.query.due_end) {
      this.dateRange = [DateTime.fromJSDate(new Date(this.$route.query.due_start)), DateTime.fromJSDate(new Date(this.$route.query.due_end))]
    }
    else {
      this.dateRange = DateRanges['This Month'];
    }
    if( this.$route.query.id){
      this.queryMerchant = this.$route.query.id.split(",");
      this.merchant = this.$route.query.id.split(",");  
    }
  },
  computed:{
    ...mapState({
      merchantsList: (state) => state.monthlydata.merchants,
    }),
    hasMoreMerchants() {
      return !!this.$store.state.monthlydata.merchantsNextPageUrl;
    },
    merchantsLoadingMore() {
      return this.$store.state.monthlydata.merchantsLoadingMore;
    },
    merchantsSearchResults() {
      return this.$store.state.monthlydata.merchantsSearchResults || [];
    },
    merchantsSearchLoading() {
      return this.$store.state.monthlydata.merchantsSearchLoading;
    },
  },
  methods: {
    onMerchantsSearchInput(term) {
      if (!term || !term.trim()) {
        this.$store.dispatch(CLEAR_MERCHANTS_SEARCH);
      } else {
        this.$store.dispatch(SEARCH_MERCHANTS, { search: term.trim(), is_merchant: 'True' });
      }
    },
    loadMoreMerchants() {
      this.$store.dispatch(LOAD_MORE_MERCHANTS);
    },
    filterMerchants(eventip){
      if(eventip == null || eventip.length == 0){
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
        this.merchant =null;
        this.getAnalytics();
      }
      else{
        this.merchant = eventip.map((item)=> item.id);
        this.getAnalytics()
      }
    },
    getDifferencePrevious(selection, refdate) {
      switch (selection) {
        case 'This Month':
          return refdate.minus({ months: 1 }).toUTC().toString().replace("Z","+00:00")
        case 'This Quarter':
          return refdate.minus({ months: 3 }).toUTC().toString().replace("Z","+00:00")
        case 'This Year':
          return refdate.minus({ year: 1 }).toUTC().toString().replace("Z","+00:00")
        default:
          return refdate.toUTC().toString().replace("Z","+00:00")
      }
    },
    getAnalytics() {
      this.loading = true;
      this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
      let params = {}
      if (this.dateRange !== void 0) {
        let diffTime = Math.abs(new Date(this.dateRange[1] - new Date(this.dateRange[0])));
        this.diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        params = {
          "due_start": this.dateRange[0].toUTC().toString().replace("Z","+00:00"),
          "due_end": this.dateRange[1].toUTC().toString().replace("Z","+00:00"),
        }
        if(this.dateRange[2].startsWith('This')){
          params["pre_start"] = this.getDifferencePrevious(this.dateRange[2], this.dateRange[0]);
          params["pre_end"] = this.getDifferencePrevious(this.dateRange[2], this.dateRange[1]);
        }else{
          params["pre_start"] = this.dateRange[0].minus({ days: this.diffDays }).toUTC().toString().replace("Z","+00:00");
          params["pre_end"] = this.dateRange[0].toUTC().toString().replace("Z","+00:00")
        }
        
        let currentPath = this.$route.path;
        const payload = validateAdminQueryParameter({'due_start':this.dateRange[0].toUTC().toString(),"due_end": this.dateRange[1].toUTC().toString()});
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
      }
      if (this.merchant) {
        params = {
          ...params,
          "id": this.merchant.join(',')
        };
        let currentPath = this.$route.path;
        const payload = validateAdminQueryParameter({'id':this.merchant.join(',')});
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
      }
      AnalyticsService.get('kpi', params)
        .then(({data}) => {
          this.data = data.stats;
        })
        .catch((error) => {
          console.log(error);
          this.$showAlert(error.message, 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterPayablesAnalyticsByDate(date_range) {
      let { startDate, endDate, label } = date_range;
      if (typeof startDate === 'string') {
        startDate = DateTime.fromISO(startDate);
      }
      if (typeof endDate === 'string') {
        endDate = DateTime.fromISO(endDate);
      }

      this.dateRange = [startDate, endDate, label];
      this.getAnalytics(this.merchant)
    },
  },
};
</script>
<style lang="scss" scoped>
</style>